import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth/guards';
import { WithHeaderComponent } from './app/views/with-header/with-header.component';
import { WithoutHeaderComponent } from './app/views/without-header/without-header.component';
import { routes as dynamicUiRoutes } from './dynamic-ui/dynamic-ui-routing.module';
import { WithSimpleHeaderComponent } from './app/views/with-simple-header/with-simple-header.component';

const routes: Routes = [
  { path: 'p1', component: WithoutHeaderComponent, title: "Easy Anlass", data: { title: "Willkommen" } , children: dynamicUiRoutes},
  { path: 'p2', component: WithSimpleHeaderComponent, title: "Easy Anlass", data: { title: "Willkommen" } , children: dynamicUiRoutes},
  { path: 's', component: WithSimpleHeaderComponent, title: "Easy Anlass", data: { title: "Anmeldung" } , children: dynamicUiRoutes },
  { path: 'a', component: WithHeaderComponent, title: "Easy Anlass", data: { title: "Willkommen" } , children: dynamicUiRoutes, canActivate: [AuthGuard] },
  { path: '', component: WithHeaderComponent, title: "Easy Anlass", data: { title: "Willkommen" } , children: dynamicUiRoutes },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
